export default __webpack_public_path__ + "static/media/select_arrow_down.9a599952.svg";